import { render, staticRenderFns } from "./SubmerchantPage.vue?vue&type=template&id=14c306d5&"
import script from "./SubmerchantPage.vue?vue&type=script&lang=js&"
export * from "./SubmerchantPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports